module.exports = __webpack_public_path__ + "img/videocb.a3e894cd.png";